<template>
<div class="form">
    <b-row>
        <b-col md="6">
            <b-form-group horizontal :label-cols="3" :label="$lang('姓名：')">
                <b-form-input type="text" v-model="value.name" name="name" :class="errors.has('name') && 'is-invalid'" v-validate="{...rules.name, required: requiredType}" :placeholder="$lang('請輸入名字')" :disabled="disabled" />
                <b-form-invalid-feedback :state="errors.has('name')">
                    {{ errors.first("name") }}
                </b-form-invalid-feedback>
            </b-form-group>
        </b-col>
        <b-col md="6">
            <b-form-group horizontal :label-cols="3" :label="$lang('出生年份：')">
                <DatePicker type="year" v-model="value.bornAt" name="bornAt" size="large" :class="errors.has('bornAt') && 'is-invalid'" v-validate="{...rules.birth, required: requiredType}" format="yyyy" :disabled="disabled"></DatePicker>
                <b-form-invalid-feedback :state="errors.has('bornAt')">
                    {{ errors.first("bornAt") }}
                </b-form-invalid-feedback>
            </b-form-group>
        </b-col>
        <b-col md="6">
            <b-form-group horizontal :label-cols="3" :label="$lang('性別：')">
                <b-select v-model="value.gender" name="sex" :class="errors.has('sex') && 'is-invalid'" v-validate="{...rules.sex, required: requiredType}" :placeholder="$lang('請輸入性別')" :disabled="disabled">
                    <option value="M">{{ $lang("FIELD_MALE") }}</option>
                    <option value="F">{{ $lang("FIELD_FEMALE") }}</option>
                </b-select>
                <b-form-invalid-feedback :state="errors.has('sex')">
                    {{ errors.first("sex") }}
                </b-form-invalid-feedback>
            </b-form-group>
        </b-col>
        <!-- <b-col md="6">
            <b-form-group horizontal :label-cols="3" :label="$lang('電郵：')">
                <b-form-input type="text" v-model="value.email" name="email" :class="errors.has('email') && 'is-invalid'" v-validate="'required|email'" :placeholder="$lang('請輸入電郵')" :disabled="disabled" />
                <b-form-invalid-feedback :state="errors.has('email')">
                    {{ errors.first("email") }}
                </b-form-invalid-feedback>
            </b-form-group>
        </b-col> -->
        <b-col md="6" v-if="value.hasOwnProperty('phone')">
            <b-form-group horizontal :label-cols="3" :label="$lang('電話號碼：')">
                <b-form-input type="text" v-model="value.phone" name="phone" :class="errors.has('phone') && 'is-invalid'" v-validate="{ ...rules.mobile, mobile: value.phone, required: requiredType}" :placeholder="$lang('請輸入電話號碼')" :disabled="disabled" />
                <b-form-invalid-feedback :state="errors.has('phone')">
                    {{ errors.first("phone") }}
                </b-form-invalid-feedback>
            </b-form-group>
        </b-col>
        <b-col md="6">
            <b-form-group horizontal :label-cols="3" :label="$lang('FIELD_ID_NUMBER_TYPE')">
                <b-input-group>
                    <b-form-select v-model="value.idType" name="idType" :class="errors.has('idType') && 'is-invalid'" v-validate="{ required: requiredType }" :disabled="disabled">
                        <option value="1">{{ $lang("TEXT_ID_TYPE_MACAO") }}</option>
                        <option value="2">{{ $lang("TEXT_ID_TYPE_PASSPORT")}}</option>
                        <option value="3">{{ $lang("TEXT_ID_TYPE_OTHER") }}</option>
                    </b-form-select>
                    <b-form-invalid-feedback :state="errors.has('idType')">
                        {{errors.first("idType")}}
                    </b-form-invalid-feedback>
                </b-input-group>
            </b-form-group>
        </b-col>
        <b-col md="6">
            <b-form-group horizontal :label-cols="3" :label="$lang('FIELD_ID_NUMBER')">
                <b-form-input type="text" v-model="value.idNumber" name="idNumber" :class="errors.has('idNumber') && 'is-invalid'" v-validate="{ required: requiredType }" :placeholder="$lang('請輸入證件號碼')" :disabled="disabled" />
                <b-form-invalid-feedback :state="errors.has('idNumber')">
                    {{ errors.first("idNumber") }}
                </b-form-invalid-feedback>
            </b-form-group>
        </b-col>
        <!-- <b-col md="6">
            <b-form-group horizontal :label-cols="5" :label="$lang('是否需要接駁車：')">
            <b-form-select
                v-model="value.isNeedCar"
                :options="options"
                :class="errors.has(`isNeedCar`) && 'is-invalid'"
                v-validate="{required: requiredType}"
                :disabled="disabled"
                name="isNeedCar"
            ></b-form-select>
            <b-form-invalid-feedback :state="errors.has(`isNeedCar`)">
                {{ errors.first(`isNeedCar`) }}
            </b-form-invalid-feedback>
        </b-form-group>
        </b-col> -->
        <b-col md="6" v-if="!disabled">
            <slot name="remove"></slot>
        </b-col>
    </b-row>
</div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            default () {
                return {
                    name: "",
                    gender: "M",
                    phone: "",
                    bornAt: "",
                    idType: "",
                    idNumber: "",
                    // email: ""
                };
            }
        },
        disabled: {
            type: Boolean,
            default: false
        },
        rules: {
            type: Object
        },
        requiredType: {
            type: Boolean
        },
        // participateDate: {
        //     type: Array
        // }
    },
    data() {
        return {
            // options: [
            //     { text: this.optionYes, value: true },
            //     { text: "否", value: false }]
        }
    },
    computed: {
        options() {
            return [
                { text: this.$lang("boolean.yes"), value: true },
                { text: this.$lang("boolean.no"), value: false }]
        }
    },
    methods: {
        onSubmit() {
            return new Promise((resolve, reject) => {
                this.$validator.validate().then(result => {
                    resolve(result);
                });
            });
        },
        validateErrors(field, msg) {
            this.errors.add({
                field,
                msg
            });
        }
    }
};
</script>
